import { type LabelHTMLAttributes } from 'react';
import { cn } from '@/client/lib/utils';

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={cn(
        'block font-sans text-body-small font-medium text-text-primary mb-1.5',
        className,
      )}
      {...props}
    />
  );
}
